<template>
    <ProductCardShablone v-if="product" :card="product['0']" :reaction="false" :showOne="true" :edit="product['0'].self ?? false"/>
    <div v-else>
        <p>در حال بارگذاری...</p>
    </div>
</template>
<script setup>
    import { onMounted, ref , defineProps } from 'vue'
    import ProductCardShablone from '@/components/dashboard/bodys/product/card/ProductCardShablone.vue'
    import { useProductStore } from '@/stores/product'
    const store = useProductStore()
    const props=defineProps({
        id:Number
    })
    const product = ref(null)
    onMounted(async () => {
        product.value = await store.fetchProductById(props.id)??null
    })
</script>